import { Routes } from '@angular/router';
import { MultiSiteAnalysisComponent } from './multi-site-analysis.component';
import { RouteAccessService } from '../shared';
import { MultiSiteStudyComponent } from './multi-site-study.component';

export const MULTI_SITE_ANALYSIS_ROUTES: Routes = [
    {
        path: 'multi-site-analysis',
        component: MultiSiteAnalysisComponent,
        data: { pageTitle: 'multi-site-analysis.title' },
        children: [
            {
                // :studyId param is to track active link
                path: 'study/:studyId',
                component: MultiSiteStudyComponent,
                canActivate: [RouteAccessService],
                data: { pageTitle: 'multi-site-analysis.title' }
            }
        ]
    }
];
